import React, {useEffect} from 'react';
import {useSelector} from "react-redux";
import {getObject} from "../../hooks/getObject";
import CardInfo from "../CardInfo/CardInfo";
import {BX24} from "../../hooks/BX24";

const Table = () => {

    const {users, range_date, data_about_users} = useSelector(state => state.main)

    return (
        <div className={'overflow-auto relative w-full max-w-full'}>
            <table className={'m-auto mt-10 w-full'}>
                <thead className={'sticky top-0 left-0'}>
                <tr>
                    <th className={'border border-black px-4 py-2 w-12'}>Дата</th>
                    {users.map((user, index) =>
                        <th key={index + 1}
                            className={'border border-black px-4 py-2 w-64'}
                        >
                            {user.NAME} {user.LAST_NAME}
                        </th>
                    )}
                </tr>
                </thead>

                <tbody>
                {range_date.map((date, index) => (
                    <tr key={index + 1}>
                        <td className={'border border-black px-4 py-2 text-xl font-bold w-12'}>{date}</td>
                        {users.map((user, index) =>
                            <td style={{maxWidth: '200px'}} className={'border border-black w-64'} key={index + 1}>
                                {data_about_users.map((data, index) => (`user_${user.ID}` === getObject(data.PROPERTY_326) && getObject(data.PROPERTY_338).indexOf(date) !== -1) ?
                                    <CardInfo
                                        key={index + 1}
                                        date={getObject(data.PROPERTY_338)}
                                        name_client={(data.PROPERTY_340) ? getObject(data.PROPERTY_340) : 'Имя не указано'}
                                        phone={(data.PROPERTY_332) ? getObject(data.PROPERTY_332) : 'Телефон не указан'}
                                        status={(data.PROPERTY_336) ? getObject(data.PROPERTY_336) : 'Статус не указан'}
                                        title={data.NAME}
                                        address={(data.PROPERTY_330) ? getObject(data.PROPERTY_330) : 'Адрес не указан'}
                                        id_task={(data.PROPERTY_324) ? getObject(data.PROPERTY_324) : 0}
                                        comment={(data.PROPERTY_334) ? getObject(data.PROPERTY_334) : '-'}
                                    />
                                    :
                                    '')}
                            </td>
                        )}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default Table;